import { Backdrop, SxProps, Theme, Typography } from '@mui/material';

import { Loader } from './Loader';

interface OverlayLoaderProps {
  open: boolean;
  message?: string;
}

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    background: 'rgba(250, 251, 255, 0.6)',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export function OverlayLoader({ open, message }: OverlayLoaderProps) {
  return (
    <Backdrop
      sx={customStyles.root}
      open={open}
    >
      <Loader message={message} />
    </Backdrop>
  );
}
